import React from 'react';
import { connect } from 'react-redux';

import withStyles from '@mui/styles/withStyles';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';

// @mui/icons-material
import Close from '@mui/icons-material/Close';

import modalStyle from '../assets/jss/crm/modalStyle.jsx';

import CrmButton from './CrmButton';

/*
Cribbed from Material Dashboard's Notifications.jsx view

Call it with
  <Modal
    open={T/F}
    title="<Text to appear in title>"
    hideButtons={T/F}
    okButtonLabel="<whatever>"
    cancelButtonLabel="<whatever>"
    onOk={<function to call when dialog is closed with "OK">}
    onCancel={<function to call when dialog is closed with "Cancel">}
  >
    <div>
       Some content
    </div>
    <div>
       More content
    </div>
  </Modal>
*/

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class Modal extends React.Component {
  cancelUnlessBackdropClick(event, reason, onCancel) {
    if (reason !== 'backdropClick') {
      onCancel(event, reason);
    }
  }

  render() {
    const { classes, open, title, onOk, onCancel } = this.props;
    let { okButtonLabel, cancelButtonLabel } = this.props;
    okButtonLabel = okButtonLabel || 'OK';
    cancelButtonLabel = cancelButtonLabel || 'Cancel';

    return (
      <Dialog
        classes={{
          root: /* classes.center + " " +*/ classes.modalRoot,
          paper: classes.modal,
        }}
        open={!!open}
        TransitionComponent={Transition}
        disableEscapeKeyDown={true}
        onClose={(event, reason) => cancelUnlessBackdropClick(event, reason, onCancel)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <DialogTitle id="modal-title" className={classes.modalHeader}>
          <IconButton className={classes.modalCloseButton} onClick={onCancel} size="large">
            <Close className={classes.modalClose} />
          </IconButton>
          {title}
        </DialogTitle>
        <DialogContent id="modal-description" className={classes.modalBody}>
          {this.props.children}
        </DialogContent>
        {!this.props.hideButtons && (
          <DialogActions className={classes.modalFooter}>
            <CrmButton outlined onClick={onCancel}>
              {cancelButtonLabel}
            </CrmButton>
            <CrmButton filled onClick={onOk}>
              {okButtonLabel}
            </CrmButton>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

export default connect(null, null, null, { forwardRef: true })(withStyles(modalStyle)(Modal));
